// extracted by mini-css-extract-plugin
export var button = "_bv-4";
export var hasDarkBackground = "_bv-7";
export var hasLightBackground = "_bv-6";
export var iconWrapper = "_bv-0";
export var large = "_bv-2";
export var medium = "_bv-1";
export var small = "_bv-5";
export var xsmall = "_bv-3";